import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import React from 'react';

export type CommentsListProps = {} & React.PropsWithChildren<UIComponent>;

function CommentsListComp({ children, className, ...otherProps }: CommentsListProps): React.ReactElement {
  const bem = useBemCN('comments-list');

  return (
    <div {...bem(null, null, className)} {...otherProps}>
      {children}
    </div>
  );
}

export const CommentsList = withComponentErrorBoundary<CommentsListProps>(CommentsListComp);
